export const MIN_VALUE = 1;
export const MAX_VALUE = 99;
export const DEFAULT_VALUE = 1;
